<template>
  <div class="info-block">
    <div class="texts">
      <div class="title">
        <span v-bind:style="styleClass"> {{ title }} </span>
      </div>
      <br />
      <div class="description">
        <span v-bind:style="styleClass"> {{ description }} </span>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Inserir título', required: true },
    description: { type: String, default: 'Inserir descrição', required: true },
    styleClass: { type: Object, default: undefined },
  },
}
</script>

<style scoped>
.info-block {
  width: 300px;
  height: 100%;
  background: white;
}
.logo {
  width: 300px;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
}
.logo img {
  width: 100%;
  height: 100%;
}
.texts {
  margin: 0 auto;
}
.texts > div {
  margin: 0.6rem 0;
}
.texts .title {
}
.texts .title span {
  font-weight: bold;
  font-size: 3.4em;
  line-height: 60px;
  color: #202020;
}
.texts .description {
  max-width: 210px;
}
.texts .description span {
  font-weight: 400;
  font-size: 1em;
  color: #202020;
}

@media screen and (max-width: 700px) {
  .logo img {
    width: 240px;
  }
}
</style>
